import { graphql } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { RichTextElement } from '@kontent-ai/gatsby-components';
import useResolveRichTextInternalLink from '@/components/RichTextBlock/hooks/useResolveRichTextInternalLink';
import { isRichTextValid } from '@/components/RichTextBlock/utils';
import {
  Container,
  LoginLinksContainer,
  SSOLinkContainer,
  LegalTextContainer,
  SeparatorText,
  SeparatorWrapper,
  StyledSSOLink,
} from './CloudLoginForm.styles';
import LoginLink from '@/components/LoginSection/components/LoginLink/LoginLink';

const CloudLoginForm = ({
  cloudLoginFormElements: elements,
  system,
}: Queries.CLOUD_LOGIN_FORMFragment) => {
  const { login_links, sso_link, legal_text } = elements;
  const { t } = useTranslation();

  const loginLinks = login_links.value;
  const hasSSOLink = typeof sso_link?.value?.__typename === 'string';
  const hasLegalText = isRichTextValid(legal_text?.value);

  return (
    <Container data-codename={system.codename}>
      <LoginLinksContainer>
        {loginLinks.map((link) => (
          <LoginLink key={link.system.id} {...link} size="small" />
        ))}
      </LoginLinksContainer>
      {hasLegalText && (
        <LegalTextContainer>
          <RichTextElement
            value={legal_text.value}
            links={legal_text.links}
            resolveLink={useResolveRichTextInternalLink}
          />
        </LegalTextContainer>
      )}
      {hasSSOLink && (
        <>
          <SeparatorWrapper>
            <SeparatorText>{t('form.OR')}</SeparatorText>
          </SeparatorWrapper>
          <SSOLinkContainer>
            <StyledSSOLink {...sso_link.value} variant="primary" />
          </SSOLinkContainer>
        </>
      )}
    </Container>
  );
};

export const fragment = graphql`
  fragment CLOUD_LOGIN_FORM on kontent_item_cloud_login_form {
    __typename
    system {
      codename
    }
    cloudLoginFormElements: elements {
      login_links {
        value {
          ...LOGIN_LINK
        }
      }
      sso_link {
        value {
          system {
            id
          }
          ...LINK
        }
      }
      legal_text {
        value
        links {
          link_id
          codename
        }
      }
    }
  }
`;

export default CloudLoginForm;
